import { setFetchingCart } from "@/redux/slice/cart/slice";
import { handleServerCartResponse } from "@/redux/slice/cart/utils/handleServerCartResponse";
import { BuildClientPayload } from "@/components/common/types/BuildClientPayload";
import { ThunkResolvedStatus } from "@/libs/enum/ThunkResolvedStatus";
import { fetchCartV2, fetchCartV2Variables } from "@/components/graphql/types/fetchCartV2";
import { FETCH_CART_V2 } from "@/components/graphql/serverCartV2";

type FetchServerCartInput = BuildClientPayload & {
  patientId: string;
};

export const fetchServerCart = async (fetchServerCartInput: FetchServerCartInput, dispatch) => {
  const { patientId, apolloClient } = fetchServerCartInput;

  if (patientId) {
    dispatch(setFetchingCart(ThunkResolvedStatus.pending));
    await apolloClient
      .query<fetchCartV2, fetchCartV2Variables>({
        query: FETCH_CART_V2,
        variables: {
          patientId,
        },
        fetchPolicy: "no-cache",
      })
      .then(async (response) => {
        const fetchCartResponse = response?.data?.fetchCartV2;
        await handleServerCartResponse(fetchCartResponse, dispatch);
      })
      .then(() => {
        dispatch(setFetchingCart(ThunkResolvedStatus.fulfilled));
      })
      .catch((fetchCartError) => {
        console.error("Failed to fetch server cart", fetchCartError);
        dispatch(setFetchingCart(ThunkResolvedStatus.rejected));
      });
  }
};
